/* Etiquetas multiidoma en inglés. */
export default {
  "bookingView.agencyReference": "Agency reference",
};
